import * as React from "react";
import { CalendarMonth, History, Person } from "@mui/icons-material";
import {
  Tab,
  Box,
  useTheme,
  useMediaQuery,
  AppBar,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts";
import * as s from "./styles";

const MENU = [
  {
    label: "Agenda",
    path: "/",
    icon: <CalendarMonth />,
  },
  {
    label: "Histórico",
    path: "/historico",
    icon: <History />,
  },
  {
    label: "Perfil",
    path: "/perfil",
    icon: <Person />,
  },
];

interface Props {
  children: React.ReactNode;
}

export default function TabNavigation(props: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();
  const { isLogged } = useAuth();

  const getCurrentTabIndex = () => {
    const currentPath = location.pathname;
    const index = MENU.findIndex((item) => item.path === currentPath);
    return index >= 0 ? index : 0;
  };

  const [value, setValue] = React.useState(getCurrentTabIndex());

  React.useEffect(() => {
    setValue(getCurrentTabIndex());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(MENU[newValue].path);
  };

  return (
    <s.Container isMobile={isMobile}>
      {/* Header para Desktop */}
      {!isMobile && (
        <AppBar
          position="static"
          color="inherit"
          elevation={1}
          sx={{ zIndex: 2 }}
        >
          <s.DesktopHeader>
            <s.LogoImage
              src="/logo192.png"
              alt="Logo da The Best Barber Place"
            />
            {isLogged && (
              <>
                <Box sx={{ flex: 1 }} />
                <s.DesktopTabs value={value} onChange={handleChange}>
                  {MENU.map((item) => (
                    <Tab
                      key={item.path}
                      label={
                        <Typography variant="body2">{item.label}</Typography>
                      }
                      icon={item.icon}
                      iconPosition="start"
                    />
                  ))}
                </s.DesktopTabs>
              </>
            )}
          </s.DesktopHeader>
        </AppBar>
      )}

      <s.MainContent>
        <s.ContentContainer isMobile={isMobile}>
          {props.children}
        </s.ContentContainer>
      </s.MainContent>

      {/* Bottom Navigation para Mobile - apenas se estiver logado */}
      {isMobile && isLogged && (
        <s.MobileBottomNav value={value} onChange={handleChange} showLabels>
          {MENU.map((item) => (
            <s.MobileTab key={item.path} label={item.label} icon={item.icon} />
          ))}
        </s.MobileBottomNav>
      )}
    </s.Container>
  );
}
